import Axios, { AxiosError, AxiosRequestConfig } from "axios";
import useCookie from "../hooks/useCookie";
import jwtDecode, {JwtPayload} from "jwt-decode";

export const AXIOS_INSTANCE = Axios.create({
  baseURL:
    "https://" + process.env.REACT_APP_HOSTNAME ?? "https://localhost:7071",
}); //use env variable!
export const useAccessToken = () => {
  return useCookie({
    key: "access_token",
    defaultValue: "",
  });
};

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};
export const checkToken = (token: string) => {
  if (token === "") return false;
  try {
    const decoded: JwtPayload = jwtDecode(token, { header: false });
    return Date.now() / 1000 < (decoded?.exp ?? 0);
  } catch (error) {
    return false;
  }
};

export const customInstance = async <T>(
  config: AxiosRequestConfig,
  // accessToken: string
): Promise<T> => {
  console.log("Axios instance returned", config);
  // const [accessToken, updateAccessToken] = useAccessToken();
  const accessToken = getCookie("access_token");
  const isValidToken = accessToken && checkToken(accessToken);

  
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({
    ...config,
    cancelToken: source.token,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(isValidToken && { Authorization: `Bearer ${accessToken}` }),
    },
  }).then(({ data }) => data);

  // @ts-ignore
  promise.cancel = () => {
    source.cancel("Query was cancelled");
  };

  return promise;
};

export default customInstance;

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>;
